import { get } from 'lodash-es';

const byCommercialHits = (state: any) =>
  get(state, 'properties.commercialHits');

export default byCommercialHits;
